export default __webpack_public_path__ + "static/media/integrated_session_icon_bold.b016cfff.svg";